import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { fetchLiveTables } from '@/model/liveTable';

export const fetchTableForPageGames = async (context: LogicContext) => {
  const { currentTablesIdList } = context;
  if (!currentTablesIdList || !currentTablesIdList.length) {
    return {
      liveDealerTables: {},
    };
  }
  const tables = await fetchLiveTables(
    currentTablesIdList,
    context.user?.currency || config.default_currency
  );

  return {
    liveDealerTables: tables,
  };
};
